import run from '../../utilities/run';
import $ from 'jquery';
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import { setElementsFromScope, setOptionsForSelect } from "../../utilities/selectorHelpers";
const _ = require("underscore");
require("./createChannelWizard.less");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";

export default function ConnectionTab(wizard) {

	const self = this;
	const el = wizard.getWizardElement();

	const amazonCmrDomainConfigData = el.data("amazon-connection-setup");
	const retpartner = el.data("retailer-partners-info");
	const addChannel = el.data("add-channel");
	const parName = el.data("par-name");
	const parId = el.data("partner-id");
	const amazonParId = el.data("amazon-par-id");
	const amazonMktPlcParId = el.data("amazon-market-palce-par-id");
	const testAmazonConnection = el.data("test-amazon-connection-url");
	const completeConnectionSetup = el.data("complete-connection-setup-url");
	const saveConnectionSetupUrl = el.data("save-connection-setup-url");
	const viewChannelsUrl = el.data("view-channel-url");
	const viewChannelDetailUrl = el.data("view-channel-detail-url");
	const completeConnectionSetupBtn = el.find("#amazon-save-on-connection-success");
	const defaultFileFormatList = el.data("ftp-default-file-formats");
	const ftpInbDetails = el.data("ftp-inb-details");
	const ftpOubDetails = el.data("ftp-oub-details");
	const retailerPartnerFileFormat = el.data("retailer-partner-file-format");
	const fileFormatSelect = el.find(".fileFormat");
	const getRetailersExistingAmazonCredentials = el.data("retailers-existing-amazon-credentials");
	const amazonFbaConnectionExists = el.find("#amazonFbaConnectionExists");
	const amazonMarketplaceConnectionExists = el.find("#amazonMarketplaceConnectionExists");
	const realTimeApiRetailerPartnerData = el.data("retailer-realtime-api-details");
	const realTimeApiParId = el.data("realtime-api-par-id");
	const realtimeApiApplicationName = el.find("#realtimeApiApplicationName");
	const realtimeApiClientId = el.find("#realtimeApiClientId");
	const confirmationModalTxt = el.data("confirmation-modal-txt");
	let connectionStatus = "";
	let retailerSelectedFileFormat = retailerPartnerFileFormat.fileFormat;
	const submitModalFlow = new SubmitModalFlow();
	submitModalFlow.init();

	self.init = function () {
		onLoad();
	};

	self.didNavigateToForm = function () {
		done();
	};


	function onLoad() {
		if (amazonParId == parId) {

			fillAmazonData(amazonCmrDomainConfigData, retpartner);
			checkConnectionStatus(retpartner);
		} else if (amazonMktPlcParId == parId) {
			fillAmazonData(amazonCmrDomainConfigData, retpartner);
			checkConnectionStatus(retpartner);
		} else if (realTimeApiParId == parId) {
			fillRealTimeApiData(realTimeApiRetailerPartnerData, retpartner);
			manuallyActivateCompleteConnectionSetup();
		}
		else {

			fillFileFormatList(defaultFileFormatList);
			fillCrossBorderData(retpartner);
			if (retailerSelectedFileFormat != "" || retailerSelectedFileFormat != null) {
				fillRetailerFileFormat(retailerSelectedFileFormat);
			}
			fillFtpConnectionTabData(retpartner);
			fillInboundFoldersData(ftpInbDetails);
			fillOutboundFoldersData(ftpOubDetails);
		}

	}

	$("#channel-connection-fileformat").change(onFileFormatChange);
	$("#channel-connection-fileformat").on('click', onFileFormatChange);
	//$(".amazonSection").change(onAmazonSectionChange);
	$(".amazonSection").on('input', onAmazonSectionChange);

	$('.amazonFbaConnectionExists').click(function (e) {
		if (this.checked) {
			getRetailerExistingAmazonFBACredentials({ url: getRetailersExistingAmazonCredentials, success: retrevialSuccess, error: retrevialError });
		} else {
			clearAmazonData();
		}
	})

	$('.amazonMarketplaceconnectionExists').click(function () {
		if (this.checked) {
			getRetailerExistingAmazonMarketPlaceCredentials({ url: getRetailersExistingAmazonCredentials, success: retrevialSuccess, error: retrevialError });
		} else {
			clearAmazonData();
		}
	})

	function fillInboundFoldersData(ftpINB) {
		if (ftpINB.length > 0) {
			ftpINB.forEach(function (ftpINB) {
				var ftp_inb_folders = ftpINB.cdmValue;
				var trHTML = '';
				trHTML += '<tr><td>' + ftpINB.cdmValue + '</td></tr>'
				$('#inb_records_table').append(trHTML);
			});
		}
	}

	function fillOutboundFoldersData(ftpOUB) {
		if (ftpOUB.length > 0) {
			ftpOUB.forEach(function (ftpOUB) {
				var ftp_oub_folders = ftpOUB.cdmValue;
				var trHTML = '';
				trHTML += '<tr><td>' + ftpOUB.cdmValue + '</td></tr>'
				$('#oub_records_table').append(trHTML);
			});
		}

	}

	function fillFtpConnectionTabData(retpartnerJson) {
		$("#connectionDescription").val(retpartnerJson.repDescription);
		$("#shortLink").val(retpartnerJson.repStoreLink);
	}

	function fillCrossBorderData(retpartnerJson) {
		$("#fedexCrossBorderMerchantId").val(retpartnerJson.repToken);
	}

	function fillRetailerFileFormat(retailerSelectedFileFormat) {
		$("#channel-connection-fileformat").val(retailerSelectedFileFormat);
	}
	function onFileFormatChange() {
		const downloadXmlURL = el.data("download-xml-url");
		const downloadCsvURL = el.data("download-csv-url");
		let fileFormat = $('#channel-connection-fileformat').find(':selected').val();

		if (fileFormat == "XML") {
			$("#channel-connection-downloadtemplate").attr('href', downloadXmlURL);
		} else if (fileFormat == "CSV") {
			$("#channel-connection-downloadtemplate").attr('href', downloadCsvURL);
		}
	}

	function fillFileFormatList(data) {
		_.each(data, function (val, key) {
			let option = $('<option />');
			option.attr('value', key).text(val);
			fileFormatSelect.append(option);
		});
	}

	function checkConnectionStatus(data) {
		connectionStatus = data.repConnectionTest;
		if (connectionStatus == 0) {
			connectionError();
		} else if (connectionStatus == 1) {
			setConnectionSuccessOnReviewTab();
		}
	}

	function fillAmazonData(data, retpartner) {
		let amazonPartnerDescription = data.parDescription;
		let amazonSellerId = data.amazonSellerId;
		let amazonMarketplaceId = data.amazonMarketplaceId;
		let amazonConnectionDescription = retpartner.repDescription;
		let amazonConnectionStatus = retpartner.repConnectionTest;

		$("#amazonPartnerNameId").html(parName);
		$("#amazonPartnerNameId").val(parName);
		$("#amazonSellerId").val(data.amazonSellerId);
		$("#amazonMarketplaceId").val(amazonMarketplaceId);
		$("#amazonConnectionDescriptionId").val(amazonConnectionDescription);
		$(".connection-status").val(amazonConnectionStatus);

	}

	function fillRealTimeApiData(data, retpartner) {
		let realtimeApiApplicationName = retpartner.repHostName;
		let realtimeApiClientId = retpartner.repToken;

		$("#realtimeApiApplicationName").val(realtimeApiApplicationName);
		$("#realtimeApiClientId").val(realtimeApiClientId);
	}

	function clearAmazonData() {
		$("#amazonPartnerNameId").html();
		$("#amazonPartnerNameId").val("");
		$("#amazonSellerId").val("");
		$("#amazonMarketplaceId").val("");
		$("#amazonConnectionDescriptionId").val("");
	}


	$("#retPartner-save").click(function (e) {
		let canSaveConn = canSave(wizard);
		if (canSaveConn) {
			saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request: amazonCmrDomainConfigData });
		}
	});

	$(".retPartner-save").click(function (e) {
		if (completeConnectionSetupBtn.hasClass('disabled')) {
			return;
		} else {
			saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request: amazonCmrDomainConfigData });
		}

	});

	function saveConnection({ url, success, error, request }) {
		const submitModalFlow = new SubmitModalFlow({
			confirmModalBody: `<div class="q-pad-all-xl">${confirmationModalTxt}</div>`,
			onConfirmClick: function () {
				submitModalFlow.showLoadingModal();
				$.ajax({
					data: $('#create-channel-form').serialize(),
					url: url,
					dataType: "JSON",
					type: 'POST',
					success: saveSuccess,
					error: saveError
				});
			}
		});
		submitModalFlow.init();
		submitModalFlow.showConfirmModal();
	}

	function saveSuccess() {
		EditChecker.setPageClean();
		if (parId != "" && parId != amazonParId) {
			var detailPageUrl = `${viewChannelDetailUrl}&parId=${parId}&orgName=${parName}`;
			submitModalFlow.showSuccessModal();
			setTimeout(function () {
				location.href = detailPageUrl;
			}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		} else if (parId != "" && parId == amazonParId && connectionStatus == 0) {
			var detailPageUrl = `${viewChannelDetailUrl}&parId=${parId}&orgName=${parName}`;
			submitModalFlow.showSuccessModal();
			setTimeout(function () {
				location.href = detailPageUrl;
			}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		} else if (parId != "" && parId == amazonParId && connectionStatus == 1) {
			var detailPageUrl = `${viewChannelDetailUrl}&parId=${parId}&orgName=${parName}`;
			submitModalFlow.showSuccessModal();
			setTimeout(function () {
				location.href = detailPageUrl;
			}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		} else {
			EditChecker.setPageDirty();
			submitModalFlow.showFailureModal();
			/*$('#create-channel-form').unmask();*/
		}

		//Uncommented above section as it was commented by somoeone who worked on submission modal and QA raised issue regarding save Modal.
		/*if(parId != "")
		{
		  submitModalFlow.showSuccessModal();
		  setTimeout(function() {
			 const detailPageUrl = `${viewChannelDetailUrl}&$&parId=${parId}`;
			 window.location.href = detailPageUrl;
		  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}
		else{
		  submitModalFlow.showFailureModal();
		}*/

	}

	function saveError() {
		submitModalFlow.hideAllModals();
	}

	$(".test-amazon-connection").click(function (e) {
		e.preventDefault();
		let canSaveConn = canSave(wizard);
		if (canSaveConn) {
			testConnection({ url: testAmazonConnection, success: connectionSuccess, error: connectionError });
		}
	});

	function testConnection({ url, success, error }) {
		let testConnectionJson = getFromDataForTestConnection();
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'JSON',
			data: {
				parId: testConnectionJson.parId,
				parName: testConnectionJson.parName,
				amazonSellerId: testConnectionJson.amazonSellerId,
				authToken: testConnectionJson.amazonMarketplaceId,
				accessKeyId: testConnectionJson.amazonAwsAccessKeyId,
				secretKey: testConnectionJson.amazonSecretKey
			},
			success: success,
			error: error
		});
	}

	function canSave(wizard) {
		const currentForm = wizard.getActiveTargetForm();
		let isValid = true;
		if (currentForm.filter(".connection-tab").length) {
			isValid = areInputsValidForForm(currentForm);
		}
		return isValid;
	}

	function areInputsValidForForm(form) {
		let inputs = wizard.findValidatableElementsForScope(form);
		let valid = wizard.areInputsValid(inputs, { displayErrors: true });
		return valid;
	}

	function connectionSuccess(data) {
		if (data.connStatus == "Success") {
			$("#connection-status-id").val("1");
			connectionStatus = 1;
			$("#amazon-connection-success-div").removeAttr("style");
			$("#test-amazon-connection-div").attr("style", "display:none");
			$(".next-btn-channel-setup").removeAttr('disabled');
			$("#amazon-connection-failed-div").attr("style", "display:none");
			setConnectionSuccessOnReviewTab();

		} else {
			connectionError();
		}

	}

	function connectionError() {
		$("#connection-status-id").val("0");
		connectionStatus = 0;
		$("#amazon-connection-failed-div").removeAttr("style");
		setConnectionFailedOnReviewTab();
	}

	function onAmazonSectionChange() {
		$("#test-amazon-connection-div").removeAttr('style');
		connectionStatus = 0;
		$("#connection-status-id").val("0");
		$("#amazon-connection-success-div").attr("style", "display:none");
		$("#amazon-connection-failed-div").attr("style", "display:none");
		setConnectionFailedOnReviewTab();
	}


	function setConnectionFailedOnReviewTab() {
		$(".review-tab-connection-failed").removeAttr("style");
		$(".review-tab-connection-success").attr("style", "display:none");
		completeConnectionSetupBtn.addClass("disabled");
	}

	function setConnectionSuccessOnReviewTab() {
		$(".review-tab-connection-success").removeAttr("style");
		$(".review-tab-connection-failed").attr("style", "display:none");
		completeConnectionSetupBtn.removeClass("disabled");
	}


	function getFromDataForTestConnection() {
		let formData = new Object();
		formData.parId = parId;
		formData.parName = parName;
		formData.amazonSellerId = $("#amazonSellerId").val();
		formData.amazonMarketplaceId = $("#amazonMarketplaceId").val();
		formData.amazonAwsAccessKeyId = $("#amazonAwsAccessKeyId").val();
		formData.amazonSecretKey = $("#amazonSecretKey").val();
		return formData;
	}


	function getRetailerExistingAmazonMarketPlaceCredentials({ url, success, error }) {
		let parIdToBeUsedForRetreival = amazonMktPlcParId;
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'JSON',
			data: {
				parId: parIdToBeUsedForRetreival,
				parName: parName
			},
			success: success,
			error: error
		});
	}

	function getRetailerExistingAmazonFBACredentials({ url, success, error }) {
		let parIdToBeUsedForRetreival = amazonParId;
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'JSON',
			data: {
				parId: parIdToBeUsedForRetreival,
				parName: parName
			},
			success: success,
			error: error
		});
	}

	function retrevialSuccess(data) {
		fillAmazonData(data, "");
	}

	function retrevialError(data) {
		console.log("There was an issue retreiving existing connection details");
	}

	function manuallyActivateCompleteConnectionSetup() {
		completeConnectionSetupBtn.removeClass("disabled");
	}


	const cancelBtn = $(".cancel-channel-config-btn");
	const cancelURL = $("#create-channel-form").data("view-channel-url");



};



// WEBPACK FOOTER //
// ./src/pages/createChannel/connectionTab.js